module.exports = __webpack_public_path__ + "img/account_outer.e061cf5d.svg";